/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import {
  Modal, Label, Checkbox, List, Popup
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import Update from 'immutability-helper';
import { Scrollbars } from 'react-custom-scrollbars-2';
import cx from 'classnames';
import Loader from '../Loader/Loader';
import api from '../../api';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import userPic from '../../images/common/profile_icon_big.png';
import AssigningUserModal from './AssigningUserModal';
import AssigningProjectModal from './AssigningProjectModal';

class NewLocalGroupModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMCG: props.isOpenMCG,
      isOpenMAU: false,
      isOpenMAP: false,
      viewPoint: '1',
      memberChecked: false,
      projectChecked: false,
      memberCheckValue: [],
      projectCheckValue: [],
      groupName: '',
      description: '',
      selectedMemberList: [],
      selectedProjectList: [],
      membersDetail: [],
      activeIndex: '',
      popupStatus: '',
      modalAlertMsg: '',
      modalAlertTitle: '',
      modalAlert: false,
    };
    this.handleViewPostion = this.handleViewPostion.bind(this);
    this.handleGroupNameChange = this.handleGroupNameChange.bind(this);
    this.handleGroupCheckAll = this.handleGroupCheckAll.bind(this);
    this.handleProjectCheckAll = this.handleProjectCheckAll.bind(this);
    this.handleGroupCheckChange = this.handleGroupCheckChange.bind(this);
    this.handleProjectCheckChange = this.handleProjectCheckChange.bind(this);
    this.handleDescChange = this.handleDescChange.bind(this);
    this.handleRemoveMember = this.handleRemoveMember.bind(this);
    this.handleAddMember = this.handleAddMember.bind(this);
    this.handleRemoveProject = this.handleRemoveProject.bind(this);
    this.handleAddProject = this.handleAddProject.bind(this);
    this.handleMAUClose = this.handleMAUClose.bind(this);
    this.handleMAPClose = this.handleMAPClose.bind(this);
    this.handleMemberList = this.handleMemberList.bind(this);
    this.handleProjectList = this.handleProjectList.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.closeNewLocalGroupModal = this.closeNewLocalGroupModal.bind(this);
    this.closeAlertModal = this.closeAlertModal.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMCG } = this.props;

    if (prevProps.isOpenMCG !== isOpenMCG) {
      this.setState({
        isOpenMCG,
        groupName: '',
        description: '',
        selectedMemberList: [],
        selectedProjectList: [],
        memberCheckValue: [],
        projectCheckValue: [],
        modalAlertMsg: '',
        modalAlertTitle: '',
        groupNameError: '',
        viewPoint: '1',
        membersDetail: [],
        activeIndex: '',
        popupStatus: '',
      });
    }
  }

  handleClose() {
    const status = {
      isMemberPopup: false,
    };
    this.setState({
      popupStatus: status,
      activeIndex: '',
    });
  }

  handleViewPostion(e) {
    if (e.currentTarget.dataset.id === '1') {
      this.groupNM.scrollIntoView();
    } else if (e.currentTarget.dataset.id === '2') {
      this.groupMB.scrollIntoView();
    }
    this.setState({
      viewPoint: e.currentTarget.dataset.id,
    });
  }

  handleGroupNameChange(e) {
    this.setState({
      groupName: e.target.value,
      groupNameError: '',
    });
  }

  handleDescChange(e) {
    this.setState({
      description: e.target.value,
    });
  }

  handleRemoveMember() {
    const { translate } = this.props;
    const { memberCheckValue, selectedMemberList } = this.state;
    if (memberCheckValue.length === 0) {
      this.setState({
        modalAlert: true,
        modalAlertMsg: translate('modal.message.select_one_member'),
        modalAlertTitle: translate('modal.title.attention'),
      });
      return false;
    }
    const newState = selectedMemberList.filter((item, index) => {
      return memberCheckValue.indexOf(index) === -1;
    });
    this.setState({
      selectedMemberList: newState,
      memberCheckValue: [],
    });
  }

  handleAddMember() {
    this.setState({
      memberChecked: false,
      memberCheckValue: [],
      isOpenMAU: true,
    });
  }

  handleRemoveProject() {
    const { translate } = this.props;
    const { projectCheckValue, selectedProjectList } = this.state;
    if (projectCheckValue.length === 0) {
      this.setState({
        modalAlert: true,
        modalAlertMsg: translate('modal.message.select_one_project'),
        modalAlertTitle: translate('modal.title.attention'),
      });
      return false;
    }
    const newState = selectedProjectList.filter((item, index) => {
      return projectCheckValue.indexOf(index) === -1;
    });
    this.setState({
      selectedProjectList: newState,
      projectCheckValue: [],
    });
  }

  handleAddProject() {
    this.setState({
      projectChecked: false,
      projectCheckValue: [],
      isOpenMAP: true,
    });
  }

  handleMAUClose() {
    this.setState({
      isOpenMAU: false,
    });
  }

  handleMAPClose() {
    this.setState({
      isOpenMAP: false,
    });
  }

  handleMemberList(newArr) {
    const { selectedMemberList } = this.state;
    this.setState({
      selectedMemberList: Update(selectedMemberList, {
        $push: newArr,
      }),
    });
  }

  handleProjectList(newArr) {
    const { selectedProjectList } = this.state;

    this.setState({
      selectedProjectList: Update(selectedProjectList, {
        $push: newArr,
      }),
    });
  }

  handleGroupCheckAll() {
    const { memberChecked, selectedMemberList } = this.state;
    const newState = [];

    if (memberChecked) {
      this.setState({
        memberChecked: false,
        memberCheckValue: [],
      });
    } else {
      const num = selectedMemberList.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(i);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        memberChecked: true,
        memberCheckValue: unique,
      });
    }
  }

  handleProjectCheckAll() {
    const { projectChecked, selectedProjectList } = this.state;
    const newState = [];

    if (projectChecked) {
      this.setState({
        projectChecked: false,
        projectCheckValue: [],
      });
    } else {
      const num = selectedProjectList.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(i);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        projectChecked: true,
        projectCheckValue: unique,
      });
    }
  }

  handleGroupCheckChange(e, { value }) {
    const { memberCheckValue } = this.state;
    let newState;
    if (memberCheckValue.indexOf(value) > -1) {
      newState = memberCheckValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...memberCheckValue, value];
    }
    this.setState({
      memberCheckValue: newState,
    });
  }

  handleProjectCheckChange(e, { value }) {
    const { projectCheckValue } = this.state;
    let newState;
    if (projectCheckValue.indexOf(value) > -1) {
      newState = projectCheckValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...projectCheckValue, value];
    }
    this.setState({
      projectCheckValue: newState,
    });
  }

  handleSave(e) {
    e.preventDefault();
    const newMembers = [];
    const newProjectIds = [];
    const { selectedMemberList, selectedProjectList } = this.state;
    const { translate } = this.props;

    selectedMemberList.map((item) => {
      return newMembers.push(item.email);
    });

    selectedProjectList.map((item) => {
      return newProjectIds.push(item.id);
    });

    const formData = {
      name: this.state.groupName,
      description: this.state.description,
      members: newMembers,
      project_ids: newProjectIds,
    };

    if (!this.validateFields()) {
      return null;
    }

    this.setState({
      modalAlert: true,
      isLoader: true,
    });

    api
      .createSGroup(formData)
      .then(() => {
        this.setState({
          isLoader: false,
          modalAlertTitle: translate('modal.title.notice'),
          modalAlertMsg: translate('modal.message.group_update_success'),
        });
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;

        if (o.error === '422-501') {
          return this.setState({
            isLoader: false,
            //isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.message.required_group_name'),
          });
        }
        if (o.error === '422-502') {
          return this.setState({
            isLoader: false,
            //isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.message.permitted_group_member'),
          });
        }
        if (o.error === '422-503') {
          return this.setState({
            isLoader: false,
            //isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.message.use_different_group_name'),
          });
        }

        if (o.error_description) {
          this.setState({
            isLoader: false,
            //isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: o.error_description,
          });
        } else {
          this.setState({
            isLoader: false,
            //isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.error.unknow_error'),
          });
        }
      });
  }

  getProfileImg(value) {
    const profileImg = `/1/users/me/profile_image/${value}`;

    let baseUrl = '//'.concat(location.hostname);
    let profileImgUrl = '';

    if (process.env.NODE_ENV === 'development') {
      baseUrl = baseUrl.concat(':3000');
    } else {
      baseUrl = location.port !== '' ? baseUrl.concat(':', location.port) : '';
    }

    profileImgUrl = profileImg !== '' ? baseUrl.concat(profileImg) : userPic;

    return profileImgUrl;
  }

  getByteLength(text) {
    let l = 0;
    for (let i = 0; i < text.length; i++) l += text.charCodeAt(i) > 128 ? 2 : 1;
    // return text.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, '$&$1$2').length;
    return l;
  }

  getSGroupMemberDetail = (id, groupArr) => {
    const status = {
      isMemberPopup: true,
    };
    this.setState({
      membersDetail: groupArr,
      activeIndex: id,
      popupStatus: status,
    });
  };

  closeNewLocalGroupModal() {
    this.setState({
      isOpenMCG: false,
    });
    this.props.closeModal();
  }

  closeAlertModal() {
    const { translate } = this.props;
    if (this.state.modalAlertTitle.indexOf(translate('modal.title.attention')) > -1) {
      this.setState({
        modalAlert: false,
      });
    } else {
      this.setState(
        {
          modalAlert: false,
        },
        () => {
          this.props.completeCallback(200);
          this.closeNewLocalGroupModal();
        }
      );
    }
  }

  convertToString(string) {
    if (string === 'clarityadmin@insignary.com') {
      return 'Admin';
    } if (string === 'licensemanager@insignary.com') {
      return 'Licensemanager';
    }
    return string;
  }

  validateFields() {
    const { groupName } = this.state;
    const { translate } = this.props;

    const validation = {
      groupName: true,
    };

    if (groupName.trim().length === 0) {
      this.setState({
        groupNameError: translate('modal.message.required_group_name')
      });
      this.groupNM.scrollIntoView();
      this.nameInput.focus();
      validation.groupName = false;
      return false;
    }
    if (this.getByteLength(groupName) > 30) {
      this.setState({
        groupNameError: translate('modal.message.group_name_error')
      });
      this.groupNM.scrollIntoView();
      this.nameInput.focus();
      validation.groupName = false;
      return false;
    }

    return validation.groupName;
  }

  render() {
    const {
      activeIndex,
      groupName,
      description,
      selectedMemberList,
      selectedProjectList,
      memberChecked,
      memberCheckValue,
      projectChecked,
      projectCheckValue,
      viewPoint,
    } = this.state;
    const { translate } = this.props;

    const groupNameErrorClass = this.state.groupNameError !== '' ? 'show' : '';

    return (
      <Modal open={this.state.isOpenMCG} onClose={this.closeNewLocalGroupModal}>
        <div className="setting_popup default_popup" style={{ paddingTop: '140px' }}>
          <div className="setting_popup_header">
            <h2 className="popup_name">{translate('settings.list.new_local_group')}</h2>
            <a className="popup_close_button" onClick={this.closeNewLocalGroupModal}>
              <img src={closeBtn} alt="" />
            </a>
            <div className="popup_inner_menu">
              <a
                className={cx({
                  active: viewPoint === '1',
                })}
                data-id="1"
                onClick={this.handleViewPostion}
              >
                {translate('modal.title.group_information')}
              </a>
              <a
                className={cx({
                  active: viewPoint === '2',
                })}
                data-id="2"
                onClick={this.handleViewPostion}
              >
                {translate('settings.list.group_member')}
                (
                {selectedMemberList.length}
                )
              </a>
            </div>
          </div>
          <Scrollbars
            style={{
              position: 'relative',
              overflow: 'hidden',
              height: '100%',
            }}
          >
            <div className="setting_popup_contnets">
              <div className="setting_popup_content_wrap">
                <h3 className="content_title">{translate('modal.title.type')}</h3>
                <div className="setting_popup_content">
                  <div className="text_box">
                    <Label color="green" horizontal>
                      {translate('modal.title.local')}
                    </Label>
                  </div>
                </div>
              </div>
              <div className="setting_popup_content_wrap">
                <h3
                  className="content_title"
                  ref={(ref) => {
                    this.groupNM = ref;
                  }}
                >
                  {translate('settings.list.group_name')}
                  <em style={{ marginLeft: '0' }} className="asterisk" />
                </h3>
                <div className="setting_popup_content">
                  <input
                    type="text"
                    value={groupName}
                    placeholder={translate('settings.list.group_name')}
                    onChange={this.handleGroupNameChange}
                    ref={(ref) => {
                      this.nameInput = ref;
                    }}
                  />
                  <div
                    className={`error ${groupNameErrorClass}`}
                    style={{
                      marginTop: '6px',
                      marginLeft: '5px',
                      fontSize: '12px',
                      fontWeight: '700',
                      color: '#ef4136',
                    }}
                  >
                    {this.state.groupNameError}
                  </div>
                </div>
              </div>
              <div className="setting_popup_content_wrap">
                <h3 className="content_title">{translate('list.title.description')}</h3>
                <div className="setting_popup_content">
                  <textarea
                    value={description}
                    placeholder={translate('list.title.description')}
                    onChange={this.handleDescChange}
                    rows="3"
                  />
                </div>
              </div>
              <div className="setting_popup_content_wrap">
                <h3
                  className="content_title"
                  ref={(ref) => {
                    this.groupMB = ref;
                  }}
                >
                  {translate('settings.list.group_member')}
                  (
                  {selectedMemberList.length}
                  )
                  <div className="button_box">
                    <a
                      className="delete_button"
                      onClick={this.handleRemoveMember}
                      style={{ cursor: 'pointer' }}
                    >
                      {translate('modal.button.delete')}
                    </a>
                    <a
                      className="add_button"
                      onClick={this.handleAddMember}
                      style={{ cursor: 'pointer' }}
                    >
                      {translate('modal.button.add')}
                    </a>
                  </div>
                </h3>
                {selectedMemberList.length !== 0 ? (
                  <div className="setting_popup_content">
                    <div className="table_wrap table_type_3">
                      <table className="table table_type_3">
                        <colgroup>
                          <col style={{ width: '36px' }} />
                          <col style={{ width: '' }} />
                          <col style={{ width: '230px' }} />
                          <col style={{ width: '150px' }} />
                          <col style={{ width: '100px' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th>
                              <Checkbox
                                checked={memberChecked}
                                onChange={this.handleGroupCheckAll}
                              />
                            </th>
                            <th>{translate('modal.title.name')}</th>
                            <th>{translate('modal.title.email')}</th>
                            <th className="tac">{translate('modal.title.assigned_group')}</th>
                            <th className="tar">{translate('modal.title.assigned')}</th>
                          </tr>
                          {selectedMemberList.map((list, index) => {
                            return (
                              <tr key={uuidv4()}>
                                <td>
                                  <Checkbox
                                    value={index}
                                    checked={memberCheckValue.indexOf(index) > -1}
                                    onChange={this.handleGroupCheckChange}
                                  />
                                </td>
                                <td>
                                  <span className="user_icon">
                                    <img
                                      src={this.getProfileImg(list.id)}
                                      alt=""
                                      style={{ width: '17px', height: '17px', borderRadius: '50%' }}
                                    />
                                    {list.profile}
                                  </span>
                                </td>
                                <td>{this.convertToString(list.email)}</td>
                                {
                                  list.groups.length === 0 ? (
                                    <td className="tac">{list.groups.length}</td>
                                  ) : (
                                    <Popup
                                      trigger={
                                        <td className="tac" style={{ cursor: 'pointer' }}>{list.groups.length}</td>
                                      }
                                      on="click"
                                      hideOnScroll
                                      position="bottom left"
                                      open={
                                        this.state.popupStatus.isMemberPopup
                                        && activeIndex === list.id
                                      }
                                      onOpen={() => {
                                        return this.getSGroupMemberDetail(list.id, list.groups);
                                      }}
                                      onClose={this.handleClose}
                                    >
                                      <List>
                                        {this.state.membersDetail.map((item) => {
                                          return (
                                            <List.Item key={uuidv4()}>
                                              <List.Icon name="group" />
                                              <List.Content>{item}</List.Content>
                                            </List.Item>
                                          );
                                        })}
                                      </List>
                                    </Popup>
                                  )
                                }
                                <td className="tar">-</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="setting_popup_content_wrap">
                <h3 className="content_title">
                  {translate('settings.list.assigned_project')}
                  (
                  {selectedProjectList.length}
                  )
                  <div className="button_box">
                    <a
                      className="delete_button"
                      onClick={this.handleRemoveProject}
                      style={{ cursor: 'pointer' }}
                    >
                      {translate('modal.button.delete')}
                    </a>
                    <a
                      className="add_button"
                      onClick={this.handleAddProject}
                      style={{ cursor: 'pointer' }}
                    >
                      {translate('modal.button.add')}
                    </a>
                  </div>
                </h3>
                {selectedProjectList.length !== 0 ? (
                  <div className="setting_popup_content">
                    <div className="table_wrap table_type_3">
                      <table className="table table_type_3">
                        <colgroup>
                          <col style={{ width: '36px' }} />
                          <col style={{ width: '' }} />
                          <col style={{ width: '150px' }} />
                          <col style={{ width: '130px' }} />
                          <col style={{ width: '100px' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th>
                              <Checkbox
                                checked={projectChecked}
                                onChange={this.handleProjectCheckAll}
                              />
                            </th>
                            <th>{translate('modal.title.project_name')}</th>
                            <th>{translate('modal.title.project_group')}</th>
                            <th>{translate('modal.title.project_owner')}</th>
                            <th className="tar">{translate('modal.title.assigned')}</th>
                          </tr>
                          {selectedProjectList.map((list, index) => {
                            return (
                              <tr key={uuidv4()}>
                                <td>
                                  <Checkbox
                                    value={index}
                                    checked={projectCheckValue.indexOf(index) > -1}
                                    onChange={this.handleProjectCheckChange}
                                  />
                                </td>
                                <td>{list.name}</td>
                                <td>{list.member_count}</td>
                                <td>{list.owner}</td>
                                <td className="tar">-</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </Scrollbars>
          <div className="setting_popup_button_wrap">
            <a
              className="button cencel_button"
              style={{ cursor: 'pointer' }}
              onClick={this.closeNewLocalGroupModal}
            >
              {translate('modal.button.cancel')}
            </a>
            <a
              className="button save_button"
              style={{ cursor: 'pointer' }}
              onClick={this.handleSave}
            >
              {translate('modal.button.save')}
            </a>
          </div>
        </div>
        <AssigningUserModal
          isOpenMAU={this.state.isOpenMAU}
          closeModal={this.handleMAUClose}
          completeCallback={this.handleMemberList}
          //projectName={projectName}
          members={selectedMemberList}
          translate={translate}
        />
        <AssigningProjectModal
          isOpenMAP={this.state.isOpenMAP}
          isOpenMCG={this.state.isOpenMCG}
          closeModal={this.handleMAPClose}
          projects={selectedProjectList}
          completeCallback={this.handleProjectList}
          translate={translate}
        />
        <Modal open={this.state.modalAlert} onClose={this.closeAlertModal}>
          {this.state.isLoader ? (
            <Loader />
          ) : (
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.state.modalAlertTitle}</h2>
                  <p className="text">{this.state.modalAlertMsg}</p>
                  <div className="button_wrap">
                    <a onClick={this.closeAlertModal} className="center_button">
                      {translate('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
      </Modal>
    );
  }
}

export default NewLocalGroupModal;
